import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Checkbox } from 'element-react'
import { Section } from '../../views/includes/Wrappers'
import Spacer from '../../views/includes/Spacer'
import { singleLineAddress } from '../../../helpers/util'

const ownershipDefaults = ['Rented', 'Owned']
const equipmentDefaults = [
    'Forklift',
    'Trailer Spotter',
    'Railcar Mover',
    'Aerial Lift',
    'Other',
]

const FleetFilters = props => {
    const {
        storedFilters,
        updateFilterCount,
        onChange,
        onClose,
        resultCount,
        locations,
    } = props

    const defaultState = {
        locationFilters: [],
        equipmentFilters: [],
        ownershipFilters: [],
        filterApplied: false,
    }

    const initialState = {
        locationFilters: storedFilters?.locationFilters
            ? [...storedFilters?.locationFilters]
            : [],
        equipmentFilters: storedFilters?.equipmentFilters
            ? [...storedFilters?.equipmentFilters]
            : [],
        ownershipFilters: storedFilters?.ownershipFilters
            ? [...storedFilters?.ownershipFilters]
            : [],
        filterApplied: true,
    }

    const [filters, setFilters] = useState(initialState)

    const oldState = JSON.parse(JSON.stringify(filters))

    useEffect(() => {
        document
            .querySelector('.el-dialog__wrapper')
            .appendChild(document.querySelector('.filter-button-fixed'))
    }, [])

    useEffect(() => {
        let filterCount = getFilterCount(filters)
        updateFilterCount(filterCount)
        onChange(filters, filterCount)
    }, [filters])

    const onChangeCheckbox = (field, vals) => {
        setFilters({
            ...filters,
            [field]: vals,
        })
    }

    const onSubmit = () => {
        let filterCount = getFilterCount(filters)
        setFilters({
            ...filters,
            filterApplied: filterCount > 0,
        })
        onChange(filters, filterCount)
        onClose()
    }

    const onCancel = () => {
        let filterCount = getFilterCount(oldState)
        updateFilterCount(filterCount)
        onChange(oldState, filterCount)
        onClose()
    }

    const onClear = () => {
        setFilters(defaultState)
        updateFilterCount(0)
        onChange(defaultState, 0)
        onClose()
    }

    const getFilterCount = filters => {
        let filterCount = 0
        if (
            Array.isArray(filters.equipmentFilters) &&
            filters.equipmentFilters.length
        ) {
            filterCount = filterCount + filters.equipmentFilters.length
        }
        if (
            Array.isArray(filters.locationFilters) &&
            filters.locationFilters.length
        ) {
            filterCount = filterCount + filters.locationFilters.length
        }

        if (
            Array.isArray(filters.ownershipFilters) &&
            filters.ownershipFilters.length
        ) {
            filterCount = filterCount + filters.ownershipFilters.length
        }
        return filterCount
    }

    return (
        <Dialog
            title="Filters"
            size="full"
            visible={true /* Bug fix for IE */}
            customClass="app-modal"
            onCancel={onCancel}
            lockScroll={false}
        >
            {/* Filter Apply Button */}
            <div className="filter-button-fixed">
                <Button className="primary" size="mini" onClick={onSubmit}>
                    Show {resultCount} Filtered Results
                </Button>
            </div>

            <Dialog.Body>
                <div className="filters">
                    <Section>
                        <div className="options text-right">
                            <Button
                                type="text"
                                className="underline body-color tertiary-color"
                                onClick={onClear}
                            >
                                Clear
                            </Button>
                        </div>
                    </Section>

                    <Section>
                        <h6>Ownership</h6>
                        <hr className="margin-top-tiny margin-bottom-tiny" />

                        <Checkbox.Group
                            value={[...filters?.ownershipFilters]}
                            name="filteredOwnership"
                            onChange={e =>
                                onChangeCheckbox('ownershipFilters', e)
                            }
                            className="vertical descriptions"
                        >
                            {ownershipDefaults.map(option => {
                                return (
                                    <Checkbox
                                        key={'key' + option}
                                        label={'' + option}
                                    >
                                        {' '}
                                        {option}
                                    </Checkbox>
                                )
                            })}
                        </Checkbox.Group>

                        <Spacer size="small" />

                        <h6>Equipment</h6>
                        <hr className="margin-top-tiny margin-bottom-tiny" />

                        <Checkbox.Group
                            value={[...filters?.equipmentFilters]}
                            name="filteredEquipment"
                            onChange={e =>
                                onChangeCheckbox('equipmentFilters', e)
                            }
                            className="vertical descriptions"
                        >
                            {equipmentDefaults.map(option => {
                                return (
                                    <Checkbox
                                        key={'key' + option}
                                        label={'' + option}
                                    >
                                        {' '}
                                        {option}
                                    </Checkbox>
                                )
                            })}
                        </Checkbox.Group>

                        <Spacer size="small" />

                        <h6>Locations</h6>
                        <hr className="margin-top-tiny margin-bottom-tiny" />

                        <Checkbox.Group
                            value={[...filters?.locationFilters]}
                            name="filteredLocations"
                            onChange={e =>
                                onChangeCheckbox('locationFilters', e)
                            }
                            className="vertical descriptions"
                        >
                            {locations.map(option => {
                                return (
                                    <Checkbox
                                        key={'key' + option.id}
                                        label={'' + option.id}
                                    >
                                        {' '}
                                        {option.name},{' '}
                                        <span className="description">
                                            {singleLineAddress(
                                                option.shipping_street1,
                                                option.shipping_city,
                                                option.shipping_state,
                                                option.shipping_zip,
                                            )}
                                        </span>
                                    </Checkbox>
                                )
                            })}
                        </Checkbox.Group>
                    </Section>
                </div>
            </Dialog.Body>
        </Dialog>
    )
}

FleetFilters.propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object),
    resultCount: PropTypes.number,
    statusDefaults: PropTypes.arrayOf(PropTypes.string),
    storedFilters: PropTypes.shape({
        equipmentFilters: PropTypes.array,
        locationFilters: PropTypes.array,
        ownershipFilters: PropTypes.array,
    }),
    updateFilterCount: PropTypes.func,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
}

export default FleetFilters
